import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import LoginRegisterModal from '../auth/LoginRegisterModal';
import useModalState from '../../utils/useModalState';
import {
  AUTH_LOGIN_UI,
  AUTH_SIGNUP_UI,
} from '../auth/local-auth/local-auth.constants';
import { trackSignUpClick } from '../tracking/onboarding.tracking';
import { Earth } from '../../ui-library/typography';
import { Space } from '../../ui-library/space';

const LoginRegisterLinks = ({ hideSidebar }) => {
  const [Modal, isOpen, show, hide] = useModalState(LoginRegisterModal);
  const [initialUI, setInitialUI] = useState(true);
  const handleSignup = () => {
    setInitialUI(AUTH_SIGNUP_UI);
    hideSidebar();
    trackSignUpClick();
    show();
  };
  const handleLogin = () => {
    setInitialUI(AUTH_LOGIN_UI);
    hideSidebar();
    show();
  };
  return (
    <div>
      <Modal
        isOpen={isOpen}
        onHide={hide}
        redirectURL={window.location}
        initialUI={initialUI}
      />
      <Link to='#' className='menu-sidebar-sub-item' onClick={handleLogin}>
        <Earth>Login</Earth>
        <Space size={4} />
      </Link>
      <Link to='#' className='menu-sidebar-sub-item' onClick={handleSignup}>
        <Earth>Signup</Earth>
        <Space size={4} />
      </Link>
    </div>
  );
};
export default LoginRegisterLinks;
